// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "provider-comparison-table/" + chunkId + ".provider-comparison-table.js";
};